export default __webpack_public_path__ + "static/media/graceKeynoteHeadingHero_grace.5292a63d.png";